module.exports = __webpack_public_path__ + "static/img/wl.80a8627.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/wl.png
// module id = lsSF
// module chunks = 1